import Notifications from './notifications'

const NotificationsView = (): JSX.Element => {
  // returns
  return <Notifications />
}

export default NotificationsView
